import apiClient from './apiClient';

export async function getCompany() {
  const res = await apiClient.get('/company');
  return res.data.data;
}

export async function updateCompanySetup(payload) {
  const res = await apiClient.put('/company/setup', payload);
  return res.data.data;
}

export async function updateCompanyBranding(payload) {
  const res = await apiClient.put('/company/branding', payload);
  return res.data.data;
}

export async function listLocations() {
  const res = await apiClient.get('/locations');
  return res.data.data;
}

export async function createLocation(payload) {
  const res = await apiClient.post('/locations', payload);
  return res.data.data;
}

export async function updateLocation(locationId, payload) {
  const res = await apiClient.put(`/locations/${locationId}`, payload);
  return res.data.data;
}

export async function deleteLocation(locationId) {
  await apiClient.delete(`/locations/${locationId}`);
}

export async function listLowStockSettings() {
  const res = await apiClient.get('/low-stock-settings');
  return res.data.data;
}

export async function createLowStockSetting(payload) {
  const res = await apiClient.post('/low-stock-settings', payload);
  return res.data.data;
}

export async function deleteLowStockSetting(settingId) {
  await apiClient.delete(`/low-stock-settings/${settingId}`);
}

export async function listBackups() {
  const res = await apiClient.get('/backups');
  return res.data.data;
}

export async function createBackup() {
  const res = await apiClient.post('/backups');
  return res.data.data;
}

export async function restoreBackup(backupId) {
  await apiClient.post(`/backups/${backupId}/restore`);
}

export async function listSearchConfig() {
  const res = await apiClient.get('/search-config');
  return res.data.data;
}

export async function updateSearchConfig(moduleId, payload) {
  await apiClient.put(`/search-config/${moduleId}`, payload);
}
